import React, { PropTypes } from 'react';
import { pure } from 'recompose';
import { exclusionLimit } from 'funnel/constants/exclusionConfig';
import classNames from 'classnames';

class ProductHeader extends React.Component {
  static propTypes = {
    product: PropTypes.object.isRequired,
    exclusions: PropTypes.array.isRequired,
    onCreateExclusion: PropTypes.func.isRequired,
    onDeleteExclusion: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.onCreateExclusion = this.onCreateExclusion.bind(this);
    this.onDeleteExclusion = this.onDeleteExclusion.bind(this);
  }

  onCreateExclusion() {
    if (this.props.exclusions.length < exclusionLimit) {
      this.props.onCreateExclusion(this.props.product.id);
    }
  }

  onDeleteExclusion() {
    this.props.onDeleteExclusion(
      this.props.product.id,
      this.props.exclusions.length
    );
  }

  render() {
    const { product, exclusions } = this.props;

    const addClass = classNames('add circle icon', {
      disabled: exclusions.length >= exclusionLimit,
    });
    const rmClass = classNames('minus circle icon', {
      disabled: exclusions.length === 0,
    });

    return (
      <div className="th" data-visible={exclusions.length}>
        {exclusions.map(exclusion => (
          <div key={exclusion.order} className="exclusion">
            {exclusion.order}
          </div>
        ))}
        <i className={addClass} onClick={this.onCreateExclusion} />
        <i className={rmClass} onClick={this.onDeleteExclusion} />
        {product.name}
      </div>
    );
  }
}

export default pure(ProductHeader);



// WEBPACK FOOTER //
// ./src/modules/funnel/components/detail/scoring/ProductHeader.js